import { camelToSnake } from './camelToSnake'

export function camelCaseToSnake<T>(obj: T): T {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(camelCaseToSnake) as T
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[camelToSnake(key)] = camelCaseToSnake(value)
    return acc
  }, {}) as T
}
